import moment from 'moment';

export function getTimelineDays(phases) {
  let allStartDates = [];
  let allEndDates = [];

  // Flatten all work packages and collect dates
  const workPackages = phases.flatMap((phase) => phase.workPackages || []);

  workPackages.forEach((wp) => {
    if (wp.startDate) allStartDates.push(moment(wp.startDate));
    if (wp.endDate) allEndDates.push(moment(wp.endDate));
  });

  if (allStartDates.length === 0 && allEndDates.length === 0) return [];

  const minDate = moment.min([...allStartDates, ...allEndDates]);
  const maxDate = moment.max([...allStartDates, ...allEndDates]);

  const days = [];
  let current = minDate.clone();

  while (current.isSameOrBefore(maxDate, 'day')) {
    const dayStr = current.format('YYYY-MM-DD');

    const workPackagesStarting = workPackages.filter(
      (wp) => wp.startDate && moment(wp.startDate).isSame(current, 'day')
    );

    const workPackagesEnding = workPackages.filter(
      (wp) => wp.endDate && moment(wp.endDate).isSame(current, 'day')
    );

    days.push({
      date: current.clone(),
      hasWPStart: workPackagesStarting.length > 0,
      hasWPEnd: workPackagesEnding.length > 0,
      workPackagesStarting,
      workPackagesEnding,
    });

    current.add(1, 'day');
  }

  return days;
}
